module.exports = __webpack_public_path__ + "5b9b9bf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_tag/Column/bg_01.jpg
// module id = 1247
// module chunks = 2